import CommunityReports from './CommunityReports';

export default CommunityReports;
